export default {"src":"/_next/static/media/klaytn.59495fbb.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};